/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 11:07:53
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-13 19:19:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/SubscriptionBuy/index.tsx
 */
import { SectionCollapse } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Table from './Table';
import styles from './style.module.less';
import { processSubscriptionDiscounts } from './tool';
function SubscriptionBuy(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  //
  const { saleChannelUuid = '' } = useParams() as any;
  const _subscriptionDiscounts = processSubscriptionDiscounts(data) || [];
  // console.log('SubscriptionBuy', _subscriptionDiscounts);
  // console.log(
  //   'SubscriptionBuy',
  //   _subscriptionDiscounts.reduce((pre, now) => {
  //     const lenP = (now.products || []).length;
  //     console.log('(now.products', now);
  //     return pre + lenP;
  //   }, 0),
  // );
  const noProducts =
    _subscriptionDiscounts.reduce((pre, now) => {
      const lenP = (now.products || []).length;
      //   console.log('(now.products', now);
      return pre + lenP;
    }, 0) === 0;

  const noData = _subscriptionDiscounts.length === 0 || noProducts;

  const renderContent = () => {
    return (
      <div className={styles.content}>
        {noData ? (
          <div className={styles.placeholder}>
            {getI18n(
              'salesChannelProductDetail.index.nosubscriptionofthisproduct',
            )}
          </div>
        ) : (
          _subscriptionDiscounts.map((i, index) => {
            return <Table data={i} key={index} />;
          })
        )}
        {/* <div className={styles.placeholder}></div> */}
        {renderBottom()}
      </div>
    );
  };

  const renderBottom = () => {
    return (
      <Configuration
        configStart={getI18n('general.gotoStore')}
        configLink={getI18n('general.discount')}
        linkTo={`/salesChannel/discounts/subscriptionBuy/list/${saleChannelUuid}`}
        configEnd={getI18n(
          'salesChannelProductDetail.index.tomanagesubscription',
        )}
      />
    );
  };
  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={'subscription-buy'}
        titleStyle={{ height: '64px' }}
        title={
          <div className={'collapseTitle'}>
            {getI18n('salesChannelProductDetail.index.subscriptionBuy')}
          </div>
        }
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default SubscriptionBuy;
